export default __webpack_public_path__ + "static/media/logounsam.846d654b.png";